import { ErrorMessage } from '../ErrorMessage';

export const Select = ({
  label,
  error,
  errorMessage,
  options,
  placeholder,
  ...props
}) => {
  const containerClassName = 'relative h-[62px]';
  const borderBottomColor = error
    ? 'border-b-red-500/20 focus:border-b-red-500'
    : 'border-b-secondary/20 focus:border-b-secondary';
  const selectClassName = `${borderBottomColor} text-align-last-left absolute bottom-0 flex peer h-[46px] w-full border-b-2 border-x-transparent border-t-transparent bg-transparent px-0 py-4 text-xl font-medium transition placeholder:text-transparent focus:border-x-transparent focus:border-t-transparent focus:pb-2 focus:pt-2 focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:opacity-50 [&:not(:placeholder-shown)]:pb-2 [&:not(:placeholder-shown)]:pt-2`;
  const labelClassName =
    'pointer-events-none absolute start-0 top-0 flex h-full origin-top-left items-center truncate border border-transparent px-0 font-medium transition duration-100 ease-in-out peer-focus:-translate-y-3 peer-focus:scale-90 peer-focus:text-gray-500 peer-disabled:pointer-events-none peer-disabled:opacity-50 peer-[:not(:placeholder-shown)]:-translate-y-3 peer-[:not(:placeholder-shown)]:scale-90 peer-[:not(:placeholder-shown)]:text-gray-500';
  const isErrorMessageVisible = error && !!errorMessage;

  return (
    <div className="w-full">
      <div className={containerClassName}>
        <select className={selectClassName} {...props}>
          <option value="" disabled selected hidden>
            {placeholder}
          </option>
          {options.map(({ id, value, label }) => (
            <option key={id} value={value}>
              {label}
            </option>
          ))}
        </select>
        <label className={labelClassName}>{label}</label>
      </div>
      {isErrorMessageVisible && <ErrorMessage errorMessage={errorMessage} />}
    </div>
  );
};
